import * as React from 'react';
import cx from 'classnames/bind';
import styles from './FolderLabel.scss';

const classNames = cx.bind(styles);

export interface FolderLabelProps {
    folderName: string;
    isUnread: boolean;
}

/**
 * Folder label UI component, we show folder label
 * a. When we are in search and search scope is ALL FOLDERS
 * b. Valid folder exist in folderTable
 */
export const FolderLabel = ({ folderName, isUnread }: FolderLabelProps) => (
    <div className={classNames(styles.folderLabel, { [styles.isUnread]: isUnread })}>
        {folderName}
    </div>
);
